import { CommonModule } from '@angular/common';
import type { TemplateRef } from '@angular/core';
import { Component, Input, Output, EventEmitter, computed } from '@angular/core';

/**
 * Contained surface with optional title, header actions slot, padding control, and click support.
 */
@Component({
  selector: 'es-card',
  imports: [CommonModule],
  template: `
    <div
      [class]="containerClasses()"
      (click)="clickable ? clicked.emit() : null"
    >
      @if (title || headerActions) {
        <div class="flex items-center justify-between px-4 py-3 border-b border-[var(--border)]">
          <h3 class="text-base font-semibold">{{ title }}</h3>
          @if (headerActions) {
            <ng-container *ngTemplateOutlet="headerActions"></ng-container>
          }
        </div>
      }
      <div [class]="contentPadding()">
        <ng-content></ng-content>
      </div>
    </div>
  `,
})
export class CardComponent {
  @Input() title: string | null = null;
  @Input() headerActions: TemplateRef<unknown> | null = null;
  @Input() padding: 'none' | 'sm' | 'md' | 'lg' = 'md';
  @Input() clickable = false;
  @Output() clicked = new EventEmitter<void>();

  containerClasses = computed(() => {
    const base = 'rounded-lg bg-[var(--bg-card)] border border-[var(--border)] shadow-sm transition-colors';
    const hover = this.clickable ? 'hover:bg-[var(--bg-card-hover)] cursor-pointer' : '';
    return `${base} ${hover}`;
  });

  contentPadding = computed(() => {
    const paddings = { none: '', sm: 'p-2', md: 'p-4', lg: 'p-6' };
    return paddings[this.padding];
  });
}
